var i18n = require('i18n');
var pop = require('@enhancer/fe-pop');
var ajax = require('@enhancer/fe-util-ajax');

var util = {};

util.makeZero = function(num) {
  return num < 10 ? '0' + num : num;
}

util.format = function(time) {
  if (!time) {
    return '';
  }
  var date = new Date(time);
  return date.getFullYear() + '-' + util.makeZero(date.getMonth() + 1) + '-' + util.makeZero(date.getDate()) +
    ' ' + util.makeZero(date.getHours()) + ':' + util.makeZero(date.getMinutes()) + ':' + util.makeZero(date.getSeconds());
}

util.getCookie = function(name) {
  var i, cookie, cookieStr,
    cookies = document.cookie.split(";");

  for (i = 0; i < cookies.length; i++) {
    cookie = cookies[i];
    cookieStr = cookie.split("=");
    if (cookieStr && cookieStr[0].replace(/^(\s*)|(\s*)$/g, "") == name) {
      return decodeURI(cookieStr[1]);
    }
  }
}

util.setCookie = function(name, value, expire, domain, path, secure) {
  var date,
    str = escape(name) + "=" + escape(value);
  date = new Date();

  date.setTime(date.getTime() + expire);
  str += domain ? "; domain=" + domain : "";
  str += path ? "; path=" + path : "";
  str += expire ? "; expires=" + date.toGMTString() : "";
  str += secure ? "; secure" : "";
  document.cookie = str;
}

util.loadData = (function() {
  var loading = {};
  return function(url, data, type, success, ui, fail) {
    if (typeof type == 'function') {
      fail = ui;
      ui = success
      success = type;
      type = 'GET';
    }

    if (loading[url]) {
      return;
    }
    loading[url] = 1;
    ui && ui.addClass('loading');

    var opt = {
      type: type,
      url: url,
      data: data
    };
    if (type === 'POST') {
      opt.data = JSON.stringify(data);
      opt.contentType = 'application/json';
      opt.dataType = 'json';
    }
    //start loading
    opt.beforeSend = function (xhr) {
      xhr.setRequestHeader("CSRF-Token", $('#csrfToken').val());
    }
    ajax(opt, function(res) {
      if (loading[url]) {
        delete loading[url];
        ui && ui.removeClass('loading');
        if (typeof res != 'object') {
          return util.show({
            icon: 'warning',
            content: 'not login'
          });
        }
        if (res.success) {
          return success(res);
        }
        util.show({
          icon: 'error',
          content: res.message || 'failed to load data'
        });
        fail && fail();
      }
    }, function() {
      util.show({
        icon: 'error',
        content: 'failed to load data'
      });
      ui && ui.removeClass('loading');
      delete loading[url];
      fail && fail();
    })
  }
})();


util.showConfirm =  function (msg, confirm, deny, confirmText) {
  var footer = {};
  footer[confirmText || i18n('common.confirm')] = confirm;
  util.show({
    title: i18n('common.tip'),
    close: true,
    width: 300,
    content: msg,
    footer: footer,
    onHide: function (from) {
      if (from === 'close') {
        deny && deny();
      }
    }
  });
}


util.show = function(opt) {
  pop.show(opt)
}
util.hide = function() {
  pop.hide()
}

module.exports = util;


// WEBPACK FOOTER //
// ./src/app/util.js